(function() {
    'use strict';

    var ActionReasonCtrl = function($scope, $compile,  ajaxCall, xmsNotificationFactory, $uibModalInstance) {

        $scope.ngModel = {};

        $scope.fnActionReasonSubmit = function($event) {

            $event.preventDefault();
            var controllerName = angular.isDefined($scope.ngModel.controllerName) ? $scope.ngModel.controllerName : '';
            var actionName     = angular.isDefined($scope.ngModel.actionName)     ? $scope.ngModel.actionName     : '';
            var baseController = angular.isDefined($scope.ngModel.baseController) ? $scope.ngModel.baseController : '';
            var baseAction     = angular.isDefined($scope.ngModel.baseAction)     ? $scope.ngModel.baseAction     : '';

            var ajaxUrl = WEBAPP_PATH + "/"+controllerName+"/"+actionName+"?";
            var data    = $scope.ngModel;

            ajaxCall.getData(ajaxUrl, data).then(
                function(result) {
                    $scope.ok();
                    if(result.data.hasOwnProperty('redirectLink')) {
                        window.location.replace(result.data['redirectLink']);
                    } else if(result.data.reload){
                        location.reload();
                    } else {
                        xmsNotificationFactory.addObj({id: "actionReasonPop", type: "success", bodyHtml: result.data.responseMessage});
                    }
                },
                function(result) {
                    var alertMessage = "Error occurred. Please try again later..";
                    $scope.ok();
                    xmsNotificationFactory.addObj({id: "actionReasonPop", type: "danger", bodyHtml: alertMessage});
                }
            );
            $event.preventDefault();
        }
        $scope.ok = function() {
            $uibModalInstance.close(this.ngModel); // returnValue - the results will be passed back to xms-modal ng-model (passedModel)
        };

        $scope.cancel = function() {
            $uibModalInstance.dismiss('cancel');
            $uibModalInstance.close(this.ngModel);
        }

    }

    ActionReasonCtrl.$inject = ['$scope', '$compile', 'ajaxCall', 'xmsNotificationFactory', '$uibModalInstance'];
    angular.module('app').controller('ActionReasonCtrl', ActionReasonCtrl);

}());